"use client";
import React from "react";
import { TrainingCard } from "../Common/TrainingCard";

import { useGetFormations } from "@/actions/formation";
import { toBookmark } from "@/lib/bookmarks";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

const Essentials = () => {
  const { formations: allFormations } = useGetFormations();

  return (
    <section className="px-4 md:py-15 pt-3">
      <div className="max-w-346.25 mx-auto">
        <div className="flex items-center justify-between gap-4 mb-5 md:mb-[30px]">
          <h2 className="text-[18px] md:text-[40px] text-[#1B365E] font-light font-red-hat leading-5 md:leading-13.25">Les indispensables</h2>
        </div>

        {/* Swiper Slider */}
        <Swiper
          modules={[Pagination]}
          pagination={{ clickable: true }}
          slidesPerView={1.1}
          spaceBetween={24}
          breakpoints={{
            768: { slidesPerView: 2.2, spaceBetween: 24 },
            1024: { slidesPerView: 3, spaceBetween: 32 },
            1280: { slidesPerView: 4, spaceBetween: 83 },
          }}
          className="pb-15! essentials-swiper"
        >
          <style jsx global>{`
            .essentials-swiper .swiper-wrapper {
              display: flex !important;
              align-items: stretch !important;
            }
            .essentials-swiper .swiper-slide {
              height: auto !important;
              display: flex !important;
              flex-direction: column !important;
            }
          `}</style>
          {allFormations.slice(0,10).map((card) => (
            <SwiperSlide key={card.id} className="flex! flex-col h-full">
              <TrainingCard
                title={card.title}
                description={card.description}
                category={card.category}
                location={card.location}
                duration={card.duration}
                price={card.price}
                financing={card.financing ?? "N/A"}
                isNew={card.isNew}
                customClass="h-full w-full xl:w-71"
                formation={toBookmark(card)}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default Essentials;
